function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCurrency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11c0-3.9 3.1-7 7-7 2.9 0 5.4 1.8 6.5 4.4.7-.1 1.3-.2 2-.3C18.4 4.6 15 2 11 2c-5 0-9 4-9 9 0 4 2.6 7.3 6.1 8.5 0-.7.1-1.4.3-2C5.8 16.5 4 14 4 11z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14c.7.6 1.4 1 2.1 1.3.3-.6.6-1.2.9-1.7-.6-.2-1.2-.5-1.8-1L7 14zM10.5 8.5c.8-.3 1.9 0 3 .9l1.3-1.5c-1-.8-2-1.2-2.8-1.4V5h-2v1.6c-.1.1-.3.1-.4.2-1 .5-1.7 1.4-1.7 2.3 0 2.1 1.9 2.6 3.3 3 .5-.6 1.1-1.1 1.7-1.5-.3-.1-.7-.2-1-.3-1.6-.4-2-.7-2-1.2 0-.1.2-.4.6-.6zM20 28c-4.4 0-7.9-3.6-7.9-7.9 0-4.4 3.6-7.9 7.9-7.9 4.4 0 7.9 3.6 7.9 7.9.1 4.3-3.5 7.9-7.9 7.9zm0-17.9c-5.5 0-9.9 4.4-9.9 9.9s4.4 9.9 9.9 9.9 9.9-4.4 9.9-9.9c.1-5.4-4.4-9.9-9.9-9.9z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7 14.5L20 18.7l-2.7-4.2H15l2.9 4.5H15v1.5h3.8l.2.3V22h-4v1.5h4v3h2v-3h4V22h-4v-1.2l.2-.3H25V19h-2.9l2.9-4.5h-2.3z",
    fill: props.color
  }));
}

export default SvgIconCurrency;